import React from 'react'
import ReactDOM from 'react-dom'
import { Components } from '@src/containers/ElamaIndex'

const formContainer = document.getElementById('index-form')

if (formContainer) {
  const renderPlace = formContainer.getAttribute('data-renderPlace') || 'form'
  ReactDOM.render(
    <Components.IndexForm renderPlace={renderPlace} elementId="index-form" />,
    formContainer
  )
}
